import data from "../../../../../src/TextInput/TextInput.docs.json";
import * as React from 'react';
export default {
  data,
  React
};